/**
 * Student Guard
 *
 * Route guard to protect student-only routes
 * Checks if the user has the 'student' role
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRoleService } from './user-role.service';

export const studentGuard: CanActivateFn = () => {
  const roleService = inject(UserRoleService);
  const router = inject(Router);

  // Check if user is a student
  if (roleService.isStudent()) {
    return true;
  }

  // If not a student, redirect to dashboard
  console.warn('⚠️ Access denied: User is not a student');
  router.navigate(['/app/dashboard']);
  return false;
};
